<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <label tag="div">Código</label>
            <b-form-input type="text"
                         placeholder="Código"
                         v-model="form.cd"
                         name="cd">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

            <label tag="div">Descrição</label>
            <b-form-input type="text"
                         placeholder="Descrição"
                         v-model="form.descr"
                         name="descr">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

            <label tag="div">Capacidade Peso(Minima)</label>
            <currency-input
               class="form-control"
               v-model="form.capacidade_peso_min"
               :auto-decimal-mode="true"
               placeholder="Capacidade peso"
               :currency="{ suffix: 'KG'}"
               :distraction-free="getCurrency"/>
            <b-form-feedback v-text="form.errors.get('capacidade_peso_min')" v-if="form.errors.has('capacidade_peso_min')"></b-form-feedback>

            <label tag="div">Capacidade Peso(Maximo)</label>
            <currency-input
               class="form-control"
               v-model="form.capacidade_peso"
               :auto-decimal-mode="true"
               placeholder="Capacidade peso"
               :currency="{ suffix: 'KG'}"
               :distraction-free="getCurrency"/>
            <b-form-feedback v-text="form.errors.get('capacidade_peso')" v-if="form.errors.has('capacidade_peso')"></b-form-feedback>

            <label tag="div">Volume(Minimo)</label>
            <currency-input
               class="form-control"
               v-model="form.volume_min"
               :auto-decimal-mode="true"
               placeholder="Volume"
               :currency="{ prefix: ''}"
               :distraction-free="getCurrency"/>
            <b-form-feedback v-text="form.errors.get('volume_min')" v-if="form.errors.has('volume_min')"></b-form-feedback>

            <label tag="div">Volume(Maximo)</label>
            <currency-input
               class="form-control"
               v-model="form.volume"
               :auto-decimal-mode="true"
               placeholder="Volume"
               :currency="{ prefix: ''}"
               :distraction-free="getCurrency"/>
            <b-form-feedback v-text="form.errors.get('volume')" v-if="form.errors.has('volume')"></b-form-feedback>

            <label>Tipo Rodado</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_rodado"
                :options="optionsTpRodado"
                name="tp_rodado"
                plain
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback v-text="form.errors.get('tp_rodado')" v-if="form.errors.has('tp_rodado')"></b-form-feedback>

            <label>Status</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.status"
                :options="optionsLivStatus"
                name="status"
                stacked
                plain
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>

        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      statusSelected: [],
      optionsLivStatus: [],
      optionsTpRodado: [],
      errors_array: [],
      form: new Form({ cd: '',
                       descr: '',
                       param_id: '',
                       tp_rodado: '',
                       capacidade_peso: 0,
                       capacidade_peso_min: 0,
                       volume: 0,
                       volume_min: 0,
                       status: '',
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.getLivStatus();
    this.getLivTpRodado();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.param_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = '';
      this.errors_array = [];
      this.form.reset();
      this.form.status = 1;
      this.form.capacidade_peso = parseInt(0, 10);
      this.form.capacidade_peso_min = parseInt(0, 10);
      this.form.volume = parseInt(0, 10);
      this.form.volume_min = parseInt(0, 10);
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.tp_rodado = data.tp_rodado.valor;
      this.form.capacidade_peso = parseInt(data.capacidade_peso, 10);
      this.form.capacidade_peso_min = parseInt(data.capacidade_peso_min, 10);
      this.form.volume = parseInt(data.volume, 10);
      this.form.volume_min = parseInt(data.volume_min, 10);
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)

            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivStatus()
    {
        this.helpForm.params = { tabela: this.tabela,
                                coluna: 'status' };

        this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    getLivTpRodado()
    {
        this.helpForm.params = { tabela: this.tabela,
                                coluna: 'tp_rodado' };

        this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj)=>
            {
                this.optionsTpRodado.push({ text: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
